import { usePage } from './pages/PageContext'
import CookiePreferences from './CookiePreferences'
import { acompanhamentoPath, conversaPath, potencialPath, legalBusiness, legalPaths, studentPortalUrl, valoresPath, whatsAppUrlFor, youtubeChannelUrl } from './siteDestinations'

type SiteFooterProps = {
  homeHref?: string
}

export default function SiteFooter({ homeHref = '/' }: SiteFooterProps) {
  const { whatsappMessage } = usePage()
  const contactWhatsAppUrl = whatsAppUrlFor(whatsappMessage)

  return (
    <footer>
      <div className="footer-main">
        <a className="brand brand--footer" href={homeHref} aria-label="Oficina IA: início">
          <img src="/assets/logo/symbol.svg" alt="" loading="lazy" decoding="async" />
          <span><strong>Oficina IA</strong><small>Arthur Fischer · Curso de IA para iniciantes, online</small></span>{/* termo-ok: palavra buscada no Google (decisão de SEO) */}
        </a>
        <nav aria-label="Rodapé">
          <a href={studentPortalUrl}>Portal do aluno</a>
          <a href={potencialPath}>O que dá para fazer com IA</a>
          <a href={conversaPath}>A primeira conversa</a>
          <a href={acompanhamentoPath}>Como funciona o acompanhamento</a>
          <a href={valoresPath}>Valores</a>
          <a href={youtubeChannelUrl} target="_blank" rel="noopener noreferrer">Canal no YouTube</a>
          <a href={legalPaths.privacy}>Privacidade</a>
          <a href={legalPaths.terms}>Termos</a>
          <CookiePreferences />
          <a href={contactWhatsAppUrl} target="_blank" rel="noopener noreferrer">Falar com Arthur</a>
        </nav>
      </div>
      <address className="footer-legal">
        <strong>{legalBusiness.businessName}</strong>
        <span>CNPJ {legalBusiness.cnpj}</span>
        <span>{legalBusiness.address}</span>
        <a href={`mailto:${legalBusiness.email}`}>{legalBusiness.email}</a>
        <span>Empresa ativa e emissora de nota fiscal.</span>
      </address>
    </footer>
  )
}
